<template>
  <div class="form-group mt-5" :class="{ hasValue: showInput }">
    <div :class="{ invalid: isInvalid() }" ref="accountNumber">
      <input
        :readonly="config.readonly"
        ref="item"
        :type="config.InputType"
        :name="id"
        :data-vv-as="config.ErrorMessage"
        v-validate="
          `max:${config.Validation.length}|${
            config.Validation.required ? 'required' : ''
          }|min:${min}`
        "
        :maxlength="config.Validation.length"
        :id="'input' + id"
        class="form-control"
        :value="value"
        @input="update()"
        @change="doChange()"
        @blur="update()"
        @keypress="isNumber($event)"
      />
    </div>
    <label class="form-control-placeholder" :for="id">
      <span v-if="!config.UseAlternative">{{ config.Placeholder }}</span>
      <span v-if="config.UseAlternative">{{
        config.AlternativePlaceholder
      }}</span>
      <span
        class="required-star"
        v-if="config.Validation.required && config.Placeholder"
        >*</span
      >
    </label>
    <InfoText
      v-if="config.Info && showinfo()"
      :content="config.Info"
      :id="id"
    />
    <div class="invalid-mandatory" ref="error" v-if="isInvalid()">
      {{ errors.first(id) }}
    </div>
  </div>
</template>

<script>
  import InfoText from '@/components/base/InfoText';
  export default {
    components: { InfoText },
    props: ['value', 'id', 'config'],
    inject: {
      $validator: '$validator',
    },
    data() {
      return {
        showInput: false,
        innerValue: 0,
        min: 1,
        isDirty: false,
      };
    },
    watch: {
      value: function (newVal) {
        if (newVal) {
          this.showInput = true;
          this.$store.state.accountSet = true;
        } else {
          this.showInput = false;
          this.$store.state.accountSet = false;
        }
      },
    },
    methods: {
      update() {
        this.isDirty = true;
        if (this.value || this.$refs.item.value) {
          this.showInput = true;
        } else {
          this.showInput = false;
        }
        this.$store.state.account = this.$refs.item.value;
        this.innerValue = this.$refs.item.value;
        this.$emit('input', this.$refs.item.value);
      },
      doChange() {
        this.isDirty = true;
        this.$emit('getNewData');
      },
      showinfo() {
        if (
          this.config.NoInfoFor &&
          this.config.NoInfoFor.employment !== this.$store.state.employment
        ) {
          return true;
        }
        return false;
      },
      isInvalid() {
        if (
          this.isDirty == false &&
          this.$store.state.componentIsInvalid == false
        )
          return false;
        var notLongEnough = this.value.length <= this.min;
        var stepIsInvalid = this.$store.state.componentIsInvalid;
        var regNumberNotSet = this.$store.state.regSet;
        if (!notLongEnough && !this.allCharactersAre0(this.value)) {
          return false;
        }
        if (
          notLongEnough ||
          stepIsInvalid ||
          regNumberNotSet ||
          this.allCharactersAre0(this.value)
        ) {
          return true;
        } else if (
          this.value.length > this.min &&
          !regNumberNotSet &&
          !stepIsInvalid
        ) {
          return false;
        }
      },
      allCharactersAre0(string) {
        var n = string.length;
        for (var i = 1; i < n; i++) {
          if (string[i] != '0') {
            return false;
          }
        }
        return true;
      },
      isNumber(evt) {
        this.$store.state.componentIsInvalid = false;
        evt = evt ? evt : this.window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
        ) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
    },
    mounted() {
      this.showInput = !!this.value;
    },
  };
</script>
